import * as types from "../actions/actionTypes";
import * as settings from "../../shared/settingsConstants"

const initialState = {  
  // --- Default settings
  portalSettings: {
    palette: {
      primary: {
        main: settings.portalSettings.primaryColour,
        // light: will be calculated from palette.primary.main,
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        main: settings.portalSettings.secondaryColour,
      },
      custom: {
        toolbarBackground: settings.portalSettings.toolbarBackground,
        toolbarForeground: settings.portalSettings.toolbarForeground,
        toolbarBorder: settings.portalSettings.toolbarBorder,
        drawerBackground: settings.portalSettings.drawerBackground,
        drawerForeground: settings.portalSettings.drawerForeground,
        drawerActiveBackground: settings.portalSettings.drawerActiveBackground,
        logoSrc: settings.portalSettings.logoSrc,
        logoBackgroundColour: settings.portalSettings.logoBackgroundColour      
      },    
      contrastThreshold: settings.portalSettings.contrastThreshold,    
      tonalOffset: settings.portalSettings.tonalOffset,
    },
    ConsentScreenText: null
  },
  configurationSettings: {
    SelfServiceIdentificationDocumentsEnabled: settings.configurationSettings.SelfServiceIdentificationDocumentsEnabled
  },
  isSetupComplete: false,
  countries: [],
  nationalities: [],
  documentSettings: null,
  isLoading: false,
  error: "",
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case types.getPortalSettings:
      return {
        ...state,
        error: "",
        isSetupComplete: false,
      };
    case types.getPortalSettingsSuccess:
      return {
        ...state,
        portalSettings: action.settings,
        isSetupComplete: true,
      };
    case types.getPortalSettingsFallback:
      return {
        ...state,       
        isSetupComplete: true,
      };
    case types.getConfigurationSettings:
      return {
        ...state,
        error: "",
        isSetupComplete: false,
      };
    case types.getConfigurationSettingsSuccess:
      return {
        ...state,
        configurationSettings: action.settings,
        isSetupComplete: true,
      };
    case types.getConfigurationSettingsFallback:
      return {
        ...state,       
        isSetupComplete: true,
      };
    case types.getCountries:
      return {
        ...state,
        error: "",
        isLoading: true,
      };
    case types.getCountriesSuccess:
      return {
        ...state,
        countries: action.countries,
        isLoading: false,
      };
    case types.getNationalities:
      return {
        ...state,
        error: "",
        isLoading: true,
      };
    case types.getNationalitiesSuccess:
      return {
        ...state,
        nationalities: action.nationalities,
        isLoading: false,
      };
    case types.staticDataApiRequestError:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case types.getDocumentSettings:
      return {
        ...state,
        isLoading: true,
      };
      case types.getDocumentSettingsSuccess:
      return {
        ...state,
        documentSettings: action.documentSettings,
        isLoading: false,
      };
    default:
      return state;
  }
};
